<script>
  import LinkItem from '$lib/services/links/Item.svelte';
  import viewport from '@/js/utils/useViewportAction.js';

  export let homeLinks;
  let grow = false;
</script>

<section class="links">
  <div
    class="container container--large"
    class:grow
    use:viewport
    on:enterViewport={() => (grow = true)}
  >
    <h4 class="links__title" class:grow>{homeLinks.title}</h4>
    <div class="links__items-block flexbox-full" class:grow>
      {#each homeLinks.items as item (item.id)}
        <div class="links__item-and-line col col-25 col-m-50 col-s-full">
          <LinkItem {item} />
          {#if item.id !== 4}
            <div
              class="line-vertical"
              class:grow
              use:viewport
              on:enterViewport={() => (grow = true)}
            />
          {/if}
          {#if item.id !== 1}
            <div
              class="line-horizontal"
              class:grow
              use:viewport
              on:enterViewport={() => (grow = true)}
            />
          {/if}
        </div>
      {/each}
    </div>

    <p class="links__desc" class:grow>{homeLinks.desc}</p>
    {#if homeLinks.link}
      <div class="text-center">
        <a
          class="btn btn-icon btn-main btn-main--dark links__more-btn"
          class:grow
          href={homeLinks.link.url}
        >
          <span>{homeLinks.link.text}</span>
          <i class="isax isax-arrow-right-1" />
        </a>
      </div>
    {/if}
  </div>
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes grow {
    0% {
      height: 0%;
      top: 50%;
    }

    90% {
      height: 110%;
      top: -5%;
    }

    100% {
      height: 100%;
      top: 0%;
    }
  }

  .links {
    text-align: center;
    margin-bottom: 10rem;

    @include resp-max('s') {
      margin-bottom: 0;
    }

    &__title {
      max-width: 70rem;
      margin: 0 auto;

      @include resp-max('s') {
        @include h2;
        line-height: 1.32;
      }
      &.grow {
        animation: fade-up 1s ease-in-out backwards;
      }
    }

    &__desc {
      margin: 5rem auto 0;
      max-width: 70rem;
      &.grow {
        animation: fade-up 1s ease-in-out backwards;
      }
    }

    &__items-block {
      display: flex;
      margin-top: 5rem;
      flex-wrap: nowrap;
      justify-content: center;
      row-gap: 5rem;
      flex-wrap: wrap;

      @include resp-max('s') {
        row-gap: 0;
      }

      &.grow {
        animation: fade-up 1s ease-in-out backwards;
      }

      @include resp-max('l') {
        flex-wrap: wrap;
      }
    }

    &__item-and-line {
      position: relative;
      &:last-child > .line-vertical {
        display: none;
      }

      .line-vertical {
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;

        &.grow {
          animation: grow ease-in-out 1s;
        }

        @include resp-max('m') {
          display: none;
        }
      }

      .line-horizontal {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;

        &.grow {
          animation: grow ease-in-out 1s;
        }

        @include resp-min('s') {
          display: none;
        }
      }
    }

    &__more-btn {
      margin: 2rem auto;

      &.grow {
        animation: fade-up 1s ease-in-out backwards;
      }
    }
  }

  // body.page-temlate-home {
  //   .links {
  //     .container {
  //       &.grow {
  //         animation: fade-up 1s ease-in-out backwards;
  //       }
  //     }
  //   }
  // }
</style>
